import { type FC, type ReactNode } from "react";

export type ProfileVariantProps = {
    isV2: boolean;
    v1: ReactNode;
    v2: ReactNode;
};

export const ProfileVariant: FC<ProfileVariantProps> = ({ isV2, v1, v2 }) => {
    return <>{isV2 ? v2 : v1}</>;
};